module.exports = __webpack_public_path__ + "../resources/img/ic_pdf.1208aac3.svg";